<div class="kitchen-component-container page-root-container">
        <div class="page-header">
                <div class="page-title">

                        <img class="icon" src="assets/images/menu/svg/daily-sales-report.svg"><span class="title">Sales
                                Summary(Daily)</span>
                </div>


                <div class="page-actions">
                        <!-- <button mat-button color="primary" class="btn-add"
                            (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button> -->
                        @if(permission.can_export || permission.can_execute){
                        <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                        </button>
                        }
                </div>
        </div>

        <div class="data-container ">
                <app-loader [show]="isLoading"></app-loader>

                <!-- <app-search-filter #searchFilter [length]="pagingData.length" [pageSize]="pagingData.pageSize"
                    [pageSizeOptions]="[5,10,20,50,100]" [pageIndex]="pagingData.pageIndex" [filter]="filter"
                    (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"  [hidePageSize]="true">
            </app-search-filter> -->
                <app-search-filter #searchFilter [pagingData]="pagingData" [pageSizeOptions]="[5,10,20,50,100]"
                        [filter]="filter" (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)"
                        [hidePageSize]="true">
                </app-search-filter>
                <!-- <ng-container *ngIf="pagingData.length>0; else nodata"> -->
                <!-- @if(pagingData.length > 0){
                            @if(!isHandset){ -->
                <section tabindex="0" class="table-container">
                        <table matSort mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="salesGroup">
                                        <th mat-header-cell *matHeaderCellDef colspan="2" class="grouped-header">Sales
                                        </th>
                                </ng-container>
                                <ng-container matColumnDef="ordersGroup">
                                        <th mat-header-cell *matHeaderCellDef colspan="2" class="grouped-header">Orders
                                        </th>
                                </ng-container>
                                <ng-container matColumnDef="labourGroup">
                                        <th mat-header-cell *matHeaderCellDef colspan="3" class="grouped-header">Staff
                                        </th>
                                </ng-container>
                                <ng-container matColumnDef="item">
                                        <th mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                                                class="item-header">#</th>
                                        <td mat-cell *matCellDef="let sale; let i = index" class="item-column">{{
                                                (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                                </ng-container> (matSortChange)="sortData($event)">
                                <ng-container matColumnDef="sales_date">
                                        <th mat-sort-header="sales_date" mat-header-cell style="width: 120px;"
                                                *matHeaderCellDef (click)="sortData($event)">Date</th>
                                        <td mat-cell *matCellDef="let sale" style="width: 120px;">
                                                {{sale.sales_date | date: 'dd-MM-yyyy'}}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="sales_amount">
                                        <th mat-sort-header="sales_amount" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)" class="status-header"> Amount </th>
                                        <td mat-cell *matCellDef="let sale" class="amount"> {{sale.sales_amount
                                                |currency }}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="item_sold">
                                        <th mat-sort-header="item_sold" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)" class="status-header"> Item Sold </th>
                                        <td mat-cell *matCellDef="let sale" class="amount"> {{sale.item_sold}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="transactions">
                                        <th mat-sort-header="transactions" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)" class="status-header"> Transactions </th>
                                        <td mat-cell *matCellDef="let sale" class="amount"> {{sale.transactions}}
                                        </td>
                                </ng-container>



                                <ng-container matColumnDef="Staff_hours">
                                        <th mat-sort-header="Staff_hours" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)" class="status-header"> Hours </th>
                                        <td mat-cell *matCellDef="let sale" class="amount">
                                                {{sale.Staff_hours.split(':')[0] | number:'1.0-0'}}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="labour_cost">
                                        <th mat-sort-header="labour_cost" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)" class="status-header"> Cost </th>
                                        <td mat-cell *matCellDef="let sale" class="amount"> {{sale.labour_cost |
                                                currency}}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="recalculate">
                                        <th mat-header-cell *matHeaderCellDef class="status-header" style="width: 10%;">
                                                Recalculate</th>
                                        <td mat-cell *matCellDef="let sale">
                                                <button mat-raised-button color="primary"
                                                        [disabled]="recalculatingMap[formatDateToYMD(sale.sales_date)]"
                                                        (click)="onRecalculate(sale)">
                                                        {{ recalculatingMap[formatDateToYMD(sale.sales_date)] ?
                                                        'Recalculating' : 'Recalculate' }}
                                                </button>
                                        </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="groupHeaderColumns; sticky: true"></tr>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                                </tr>
                                <tr mat-row class="table-element-row" *matRowDef="let sale; columns: displayedColumns;"
                                        (click)="onRowSelected(sale)">
                                </tr>
                        </table>
                </section>

                <!-- </ng-container> -->
                <!-- <ng-template #nodata> -->
                @if(pagingData.length<=0){ <div class="no-data-container">
                        <img src="assets/images/no-data.png">
                        <span class="no-data-info">No data found. Please remove or redefine the filters if
                                any.</span>
        </div>
        <!-- </ng-template> -->
        }
</div>

</div>